<div [formGroup]="primaryContactInformationFormGroup">
    <h2 class="page-header" id="primaryContact">Primary Contact Information <small class="text-danger">Required</small></h2>
    <hr />
    <div class="mb-3 row">
        <label for="primaryContactPerson" class="col-sm-4 col-form-label text-end">Primary Contact</label>
        <div class="col">
            <university-person 
                id="primaryContactPerson" 
                formControlName="primaryContactPerson"
                [canDelete]="false"
                (onDeletePerson)="onDeletePrimaryContact()"
                [canEdit]="true"
                [isInvalid]="primaryContactPerson.errors && showErrors"></university-person>
            <div *ngIf="primaryContactPerson.invalid && primaryContactPerson.errors.required && showErrors" class="text-danger">
                <small>Primary Contact is required</small>
            </div>
            <div *ngIf="primaryContactPerson.invalid && (primaryContactPerson.errors.isActive || primaryContactPerson.errors.hasPersonCompletedCashHandlingTraining)" class="text-danger">
                <small *ngIf="primaryContactPerson.errors.isActive">Primary Contact must be an active employee</small>
                <small *ngIf="primaryContactPerson.errors.hasPersonCompletedCashHandlingTraining">Primary Contact must have completed both WCCARD and WSANS1 ICON courses in the past year</small>
            </div>
        </div>
    </div>
    <div class="mb-3 row" *ngIf="!isCashnet">
        <label for="primaryContactFax" class="col-sm-4 col-form-label text-end">Fax Number</label>
        <div class="col">
            <div class="input-group">
                <span class="input-group-text">
                    <fa-icon [icon]="['fas', 'phone']"></fa-icon>
                </span>
                <input type="text" class="form-control" id="primaryContactFax" formControlName="primaryContactFax" [ngClass]="{ 'is-invalid': primaryContactFax.errors && showErrors }" appPhoneMask>
            </div>
            <div *ngIf="primaryContactFax.invalid && showErrors" class="text-danger">
                <small *ngIf="primaryContactFax.errors.required">Fax Number is required</small>
                <small *ngIf="primaryContactFax.errors.pattern">Fax Number is not a valid fax number</small>
            </div>
        </div>
    </div>
</div>
